/**
 * Checks if a given URL belongs to the redants.sg domain or is a relative path.
 *
 * @param {string} url - The URL to check
 * @returns {boolean} Returns true if:
 *                    - The URL is a relative path (starts with /, ./ or ../)
 *                    - The URL's hostname ends with .redants.sg
 *                    Returns false otherwise
 *
 * @example
 * isRedantsDomain("/about") // true
 * isRedantsDomain("./path") // true
 * isRedantsDomain("https://redants.sg") // true
 * isRedantsDomain("https://www.redants.sg") // true
 * isRedantsDomain("https://example.com") // false
 */
export function isRedantsDomain(url: string): boolean {
  try {
    if (!url) return false;

    if (url.startsWith("#")) {
      return true;
    }

    if (url.startsWith("/") || url.startsWith("./") || url.startsWith("../")) {
      return true;
    }

    if (url.startsWith("//")) {
      url = "https:" + url;
    }

    const parsedUrl = new URL(url);
    return parsedUrl.hostname.endsWith(".redants.sg");
  } catch (error) {
    // If URL parsing fails, it might be a relative path or invalid URL
    console.warn("Error checking domain for URL:", url, error);
    return true;
  }
}

export const isThisUrlFrom = (url: string, from: string): boolean => {
  try {
    const domain = new URL(url).hostname;
    return domain.includes(from);
  } catch (error) {
    console.error("Error checking URL:", url);
    return false;
  }
};

const CAPITALIZE_EXCEPTIONS = ["China workplace", "China youths"];

export function capitalizeWords(str: string) {
  // 首字母、空格后、连字符后的字符都转大写，如 "Cross-strait relations" -> "Cross-Strait Relations"
  if (CAPITALIZE_EXCEPTIONS.includes(str)) {
    return str;
  }
  return str.replace(/(^|\s|-)\S/g, (char) => char.toUpperCase());
  // return str
  //   .toLowerCase()
  //   .split(" ")
  //   .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  //   .join(" ");
}
